import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { borderRadius, colors, spacing, breakpoints, typography } = useTheme();

  /* Extracted mandatory focus-visible styles */
  const mandatoryFocusVisibleStyles = css`
    outline: none !important;
    color: ${colors.border_black} !important;
    border: 2px solid ${colors.border_black} !important;
    background-color: ${colors.skip_yellow} !important;
    text-decoration: underline !important;
    border-radius: ${borderRadius.m} !important;
  `;
  return {
    answer: isSelected => css`
      padding-bottom: 1.5rem !important;
      width: 327px;
      ${breakpoints.l} {
        width: 391px;
      }
      
      button {
        font-size: 1.125rem;
        font-weight: 400;
        background-color: transparent;
        border: 2px solid white;
        height: 48px;
        color: ${colors.white};

        &:focus:not(:hover) {
          outline: 0;
          border: 3px solid ${colors.white};
          background-color: transparent;
          color: ${colors.white};
        }

        /* Apply the mandatory focus styles globally to all buttons when focused via keyboard */
        &:focus-visible:not(:hover) {
          ${mandatoryFocusVisibleStyles}
          div svg path {
            fill: ${colors.border_black} !important;
          }
        }
      }
 
    `,
    question: css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      align-self: stretch;
      ${breakpoints.l} {
          width: 391px;
        },
        // Hide the h5 element as per original styles, but keep it in the DOM for accessibility
        h5{
          display: none
        }
        // The following styles are applied to the button within the question component  
        button {
          border: none;
          color: ${colors.white};
          padding: 0px;
          margin: 0.5rem 0rem 0rem 0rem;
          gap: 10px !important;
          font-weight: 400 !important;
          &:hover {
            font-weight: 700 !important;
          }
          svg {
              fill: ${colors.white};
              display: block;
            }
            &:hover {
              color: ${colors.white};
              svg {
                fill: ${colors.white};
              }
            }
          &:focus-visible {
            color: ${colors.border_black};
            background-color: ${colors.skip_yellow};
            outline: none;
            text-decoration-color: ${colors.border_black};
            svg {
              fill: ${colors.border_black};
            }
          }   
        },
    `,
    link: css`
      padding: ${spacing.xs};
    `,
    inputWrapper: css`
      display: flex;
      border: 1px solid ${colors.lightGrey};
      border-radius: ${spacing.s};
      align-items: center;
      padding: 0 ${spacing.m};
      width: 300px;
    `,
    buttonNext: arrowContext => css`
      font-family: 'FS Dillon';
      width: 327px;
      height: 48px;
      background-color: ${colors.red};
      color: ${colors.white};
      border: 1px ${colors.red} solid;
      border-radius: {borderRadius.m};
      font-size: 1rem;
      margin-top: 1.5rem;
      /* Apply mandatory focus styles to the next button */
      &:focus-visible {
        ${mandatoryFocusVisibleStyles}
      }

      ${
        arrowContext === false &&
        css`
          background-color: ${colors.border_grey};
          color: ${colors.next_grey};
          border: 1px ${colors.border_grey} solid;
          cursor: initial;
        `
      }

      ${
        arrowContext === true &&
        css`
          background-color: ${colors.red};
          color: ${colors.white};
          cursor: pointer;
        `
      }

      ${breakpoints.l} {
          width: 391px;
        }
        &:not(:disabled) {
          &:hover {
            background-color: ${colors.white} !important;
            color: #16161e !important;
            border: none;
          }
        }
      `,
    input: css`
      ${typography.base};
      appearance: none;
      background-color: ${colors.white};
      border: none;
      font: inherit;
      color: ${colors.white};
      line-height: inherit;
      padding: ${spacing.s};
      transition-duration: 0.2s;
      transition-property: border-color;
      width: 100%;

      &:hover,
      &:focus-visible {
        outline: 0;
        border-color: ${colors.navy};
        background-color: ${colors.white};
        color: ${colors.navy};
      }
    `,
    locationSvg: css`
      margin-left: 8px;
    `,
    error: css`
      padding: ${spacing.xs};
      color: ${colors.red};
    `,
    /* 
      This is where we manage the "selected but unfocused" vs "focused" state.
      We remove the `isFocused` prop logic and rely on the native :focus-visible.
    */
    btnSelectedHover: (isSelected, isFocused) => css`
      /* Default state for unselected buttons (assuming this is used on buttons) */
      background-color: transparent;
      color: ${colors.white};
      border: 2px solid ${colors.white};

      ${isSelected &&
      css`
        /* Default selected style (white bg, navy text) - applies when selected */
        &.currentSelected {
          background-color: ${colors.white};
          color: ${colors.navy};
          border: 2px solid ${colors.white}; /* Ensure border is white when selected */
        }
      `}

      /* This handles keyboard focus only, overriding selected/unselected styles */
      &:focus-visible {
        ${mandatoryFocusVisibleStyles}
        div svg path {
          fill: ${colors.border_black} !important;
        }
      }

      /* The isFocused prop is now ignored visually to prevent click issues */
      /* ${isFocused && css`...`} removed */

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          background-color: ${colors.white};
          color: ${colors.navy};
        }
      }
    `,
  };
};
